angular.module('impactx.lot').controller('ExcelImportBasketsCtrl',
    ExcelImportBasketsCtrl);

ExcelImportBasketsCtrl.$inject = ['$scope', 'dataGen', '$routeParams', '$securityManager', 'ToastService', 'BackService'];

function ExcelImportBasketsCtrl($scope, dataGen, $routeParams, $securityManager, ToastService, BackService) {
    $scope.importFile = {};

    var self = this;

    self.importFile = function () {
        var fileData = {
            importFile: $scope.importFile.file
        };

        $scope.requestPending = true;
        dataGen.uploadFile(fileData, '/basket/excelimportbaskets/import').then(function (response) {
            BackService.back();
            ToastService.openStandardToast(response.trns.success);
            $scope.requestPending = false;
        }, function () {
            $scope.requestPending = false;
        });
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/basket/excelimportbaskets/get");
}